export default __webpack_public_path__ + "static/tankstelleDefault-e6d6f2934d6bc79952032143ede67820.jpg";